function getHandleFromSwatch(swatchEl) {
    if (!swatchEl) return null;
    const onclickAttr = swatchEl.getAttribute("onclick") || "";
    const match = onclickAttr.match(/redirectToProductPage\(['"]([^'"]+)['"]/);
    if (match) return match[1];

    if (swatchEl.classList.contains("selected")) {
        return window.currentProductHandle || null;
    }
    return null;
}

// Bù đắp dữ liệu bị Shopify giới hạn bằng Fetch ngầm
const fetchingHandles = new Set();
function fetchMissingResemblance(handle) {
    if (!handle || window.productResemblanceMap[handle] || fetchingHandles.has(handle)) return;
    fetchingHandles.add(handle);

    fetch(`/products/${handle}`)
        .then(res => res.text())
        .then(html => {
            const mapMatches = html.match(/productResemblanceMap\[["']([^"']+)["']\]\s*=\s*["']([^"']+)["']/g);
            if (mapMatches) {
                mapMatches.forEach(m => {
                    const parts = m.match(/productResemblanceMap\[["']([^"']+)["']\]\s*=\s*["']([^"']+)["']/);
                    if (parts && parts[1] && parts[2]) {
                        window.productResemblanceMap[parts[1]] = parts[2];
                    }
                });
                initAllCombinedListingBullets();
            }
        })
        .catch(err => console.error("Error fetching resemblance:", handle, err));
}

function initAllCombinedListingBullets() {
    const parentDiv = document.querySelector(".mpg-swatch-image-price.mpg-option-set-layout-slider.mpg-swatch__option-set");
    if (!parentDiv) return false;

    let listingEl = parentDiv.querySelector(".swt-gcombined-listing");
    if (!listingEl) {
        listingEl = document.createElement("div");
        listingEl.className = "swt-gcombined-listing";
        parentDiv.appendChild(listingEl);
    }

    const swatches = Array.from(parentDiv.querySelectorAll(".mpg-swatch__option"));
    if (!swatches.length) return false;

    let bulletsHTML = "";
    swatches.forEach(swatch => {
        const name = swatch.getAttribute("o-value") || "";
        const handle = getHandleFromSwatch(swatch);
        const isSelected = swatch.classList.contains("selected");

        let resemblance = "";
        if (window.productResemblanceMap) {
            const cleanName = name.toLowerCase().trim();
            const cleanHandle = (handle || "").toLowerCase().trim();
            if (handle && window.productResemblanceMap[handle]) {
                resemblance = window.productResemblanceMap[handle];
            } else if (name && window.productResemblanceMap[name]) {
                resemblance = window.productResemblanceMap[name];
            } else {
                const foundKey = Object.keys(window.productResemblanceMap).find(k => {
                    const cleanKey = k.toLowerCase().trim();
                    return (cleanHandle && (cleanKey.includes(cleanHandle) || cleanHandle.includes(cleanKey))) ||
                           (cleanName && (cleanKey.includes(cleanName) || cleanName.includes(cleanKey)));
                });
                if (foundKey) resemblance = window.productResemblanceMap[foundKey];
            }
        }

        // Tự động kích hoạt fetch ngầm nếu dữ liệu bị thiếu
        if (!resemblance && handle) {
            fetchMissingResemblance(handle);
        }

        if (resemblance) {
            resemblance = resemblance.replace(/^inspired\s+by\s*:?\s*/i, "").trim();
        }

        const activeClass = isSelected ? " active" : "";
        const resemblanceText = resemblance ? ` <span>${resemblance}</span>` : "";

        bulletsHTML += `<div class="swt-bullet${activeClass}" data-value="${name}">${name}${resemblanceText}</div>`;

        if (resemblance) {
            const contentEl = swatch.querySelector(".mpg-swatch__option-content");
            if (contentEl && !contentEl.querySelector(".sml-accent")) {
                const accentEl = document.createElement("div");
                accentEl.className = "sml-accent";
                accentEl.textContent = resemblance;
                contentEl.appendChild(accentEl);
            }
        }
    });

    if (listingEl.innerHTML !== bulletsHTML) {
        listingEl.innerHTML = bulletsHTML;
    }

    return true;
}

function updateTheCombinedListingValue(targetSwatch) {
    const activeSwatch = targetSwatch || document.querySelector(".mpg-swatch-image-price.mpg-swatch__option.selected");
    if (!activeSwatch) return;

    const name = activeSwatch.getAttribute("o-value") || "";
    const container = document.querySelector(".swt-gcombined-listing");
    if (!container) {
        initAllCombinedListingBullets();
        return;
    }

    const bullets = container.querySelectorAll(".swt-bullet");
    if (!bullets.length) {
        initAllCombinedListingBullets();
        return;
    }

    bullets.forEach(bullet => {
        if (bullet.getAttribute("data-value") === name) {
            bullet.classList.add("active");
        } else {
            bullet.classList.remove("active");
        }
    });
}

function createCombinedListingDiv() {
    initAllCombinedListingBullets();
}

document.addEventListener("mouseover", event => {
    const element = event.target.closest(".mpg-swatch-image-price.mpg-swatch__option.mpg-tooltip-container");
    if (!element) return;
    updateTheCombinedListingValue(element);
});

document.addEventListener("mouseout", event => {
    if (event.target.closest(".mpg-swatch-image-price.mpg-swatch__option.mpg-tooltip-container")) {
        updateTheCombinedListingValue();
    }
});

window.addEventListener("load", function() {
    let attempts = 0;
    const interval = setInterval(() => {
        const success = initAllCombinedListingBullets();
        attempts++;
        if (success || attempts >= 20) clearInterval(interval);
    }, 300);
});

window.addEventListener("load", function() {
    initAllCombinedListingBullets();
    initRebuildStars();
});

function rebuildStars() {
    const value = document.querySelector(".kl_reviews__star_rating_widget")?.ariaLabel;
    if (!value) return;

    const [star, totalReviews] = value
        .split(",")
        .map(item => parseFloat(item.trim()));

    const elem = document.querySelector(".kl_reviews__star_rating_widget__label");
    if (!elem) return;

    const wrapper = document.createElement("div");
    wrapper.className = "custom-rating";

    const ratingSpan = document.createElement("span");
    ratingSpan.className = "rating";
    ratingSpan.textContent = star;

    const totalReviewSpan = document.createElement("span");
    totalReviewSpan.className = "total-review";
    totalReviewSpan.textContent = "(" + totalReviews + ")";

    wrapper.append(ratingSpan, totalReviewSpan);

    elem.replaceChildren(wrapper);

    return "yes";
}

function initRebuildStars() {
    rebuildStars();

    let count = 1;

    const interval = setInterval(() => {
        const result = rebuildStars();
        if (result == "yes") {
            document.querySelector(".klaviyo-star-rating-widget.hidden")?.classList.remove("hidden");
        }

        if (++count >= 5) {
            clearInterval(interval);
        }
    }, 2000);
}
